import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { mixGetV1 } from "services/mixin";

const LoginByToken = () => {
  const navigate = useNavigate();

  const getProfile = async () => {
    const res = await mixGetV1("/api/v1/fe/customer/profile");

    if (res.status) {
      return res.data.info;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      const code = params.get("code")

      if (token) {
        localStorage.setItem("token", token);

        const userData = await getProfile();

        localStorage.setItem("user", JSON.stringify(userData));

        navigate('/')
      }

      if (code) {
        const res = await mixGetV1(`/api/v1/fe/google/login?code=${code}&url=https://portal.sharai.net/`)

        console.log(res)
      }
    };

    fetchData();
  }, []);

  return <h1>Redicting ...</h1>;
};

export default LoginByToken;
